export default __webpack_public_path__ + "static/media/assess.dba31b50.jpg";